// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-expandbutton_default__n_m_n"};